export const buildEndpoint = (
  path: string,
  map: Record<string, string | number>
) => {
  Object.entries(map).forEach(([key, value]) => {
    path = path.replace(`{{${key}}}`, value.toString());
  });
  return path;
};
